<template>
  <div>
    <h1>Import Users</h1>
    <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
    <el-table :data="users" style="width: 100%">
      <el-table-column prop="Name (First)" label="First Name"/>
      <el-table-column prop="Name (Last)" label="Last Name"/>
      <el-table-column prop="Email" label="Email"/>
      <el-table-column prop="Gender" label="Gender"/>
      <el-table-column prop="Date of Birth" label="DOB"/>
      <el-table-column label="Action">
        <template slot-scope="scope">
          <el-button @click="importUser(scope.row)">Import</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      users: [],
    }
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      const reader = new FileReader();
      reader.onload = ({target}) => {
        this.users = JSON.parse(target.result);
      }
      reader.readAsText(this.file);
    },
    importUser(user){
      console.log(user);
      Parse.Cloud.run("addUser", user).then( res => {
        console.log(res);
      }).catch( err => {
        console.log(err);
      });
    },
    doImport() {

    }
  }
}
</script>
